import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../../app/firebase";

export async function firebaseSignOut() {
  try {
    signOut(auth);
    return true;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export const loginAdmin = async (email, password) => {
  try {
    const resp = await signInWithEmailAndPassword(auth, email, password);
    const { uid } = resp.user;

    if (!resp) {
      return { text: "not admin", error: true };
    } else {
      return { uid, error: false };
    }
  } catch (error) {
    console.log(error.message);
    return { text: error.code, error: true };
  }
};
